import axios from '../utils/request/request'
const userActions = {
    // 登录
    login: params => axios.post('/frontend/login/login', params),
    // 用户信息
    userInfo: params => axios.post('/frontend/user/detail', params),
    // 修改用户信息
    editUserInfo: params => axios.post('/frontend/user/add', params)
}
export default userActions